import { HttpService, Query, QueryHandler, TaggedUrl, Tags } from '@skylab-shared/core';
import { OrderDirection } from './../../common/query/paged-collection-query';


export interface CurrencyItem {
    readonly id: number;
    readonly default: boolean;
    readonly name: string;
    readonly precision: number;
    readonly symbol: string;
    readonly externalId: string;
}

interface CurrencyInternalItem {
    readonly default: boolean;
    readonly id: number;
    readonly name: string;
    readonly precision: number;
    readonly symbol: string;
    readonly version: string;
    readonly externalId: string;
}

export class CurrencyCollectionQuery extends Query<CurrencyItem[]> {
    public sorting: {
        orderBy: string;
    };
}

export class CurrencyCollectionQueryHandlerBase implements QueryHandler<CurrencyCollectionQuery, CurrencyItem[]> {
    public static Url = TaggedUrl.join('system/currencies', [Tags.Api]);

    public constructor(private readonly $http: HttpService) { }

    public async handleAsync(query: CurrencyCollectionQuery): Promise<CurrencyItem[]> {
        const sorting = query.sorting ? query.sorting : { orderBy: 'symbol', direction: OrderDirection.Desc };
        const { data } = await this.$http.get<{ items: CurrencyInternalItem[] }>(CurrencyCollectionQueryHandlerBase.Url, { params: sorting });
        return data.items.map(i => ({
            id: i.id,
            default: i.default,
            name: i.name,
            precision: i.precision,
            symbol: i.symbol,
            externalId: i.externalId
        }));
    }
}
